import { CallStatus, TelnyxCallState } from 'constants/telephony';

import { CALL_STATE_LABEL, SECONDS_PER_MINUTE } from './MobileCallSurface.constants';

export const formatDuration = seconds => {
  const mins = Math.floor(seconds / SECONDS_PER_MINUTE);
  const secs = seconds % SECONDS_PER_MINUTE;

  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

export const getCallStateLabel = ({ callStatus, telnyxCallState, isOnHold }) => {
  if (callStatus === CallStatus.INCOMING) {
    return CALL_STATE_LABEL.INCOMING;
  }

  if (callStatus === CallStatus.OUTGOING) {
    if (telnyxCallState === TelnyxCallState.EARLY || telnyxCallState === TelnyxCallState.RINGING) {
      return CALL_STATE_LABEL.RINGING;
    }

    return CALL_STATE_LABEL.CONNECTING;
  }

  if (callStatus === CallStatus.ACTIVE) {
    return isOnHold ? CALL_STATE_LABEL.ON_HOLD : CALL_STATE_LABEL.IN_CALL;
  }

  return CALL_STATE_LABEL.CONNECTING;
};

export const getCallerDisplayName = call => {
  const name = call.callerName || call.dialedNumber || call.callerNumber;

  return name || 'Unknown';
};

export const getCallerDisplayNumber = call => call.callerNumber || call.dialedNumber || '';
